import styled from './modalfatu.module.css'
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../services/global';
import api from '../../services/api';
import { Alerta } from '../../utils/functions';


function ModalFatu() {
    const { setIsOpenF } = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const { fatcli, qtdfun } = useContext(AuthContext);


    const [fat, setFat] = useState(fatcli);
    const [qtd, setQtd] = useState(qtdfun);

    function closeModal() {
        setIsOpenF(false);
    }

    async function PutInfo() {
        await api.post(`info/info?qtdfun=${qtd}&fatcli=${fat}&cgccli=${cgccli}`)
            .then((response) => {
                if (!response.data.errocod) {
                    closeModal();

                    Alerta('Sucesso', 'Alteração realizada com sucesso!', 'success');
                } else {
                    closeModal();
                    Alerta('Erro', response.data.errocod, 'error')
                }
            }).catch((erro) => {
                closeModal();
                Alerta('Erro', erro, 'error')
            })
    }


    return (

        <div className={styled.modal}>
            <div className={styled.modalheader}>
                <a>Atualizar Informações</a>
                <div className={styled.cardtitleline}></div>
            </div>
            <div className={styled.modalcontent}>
                <div className={styled.appmodal}>
                    <div className={styled.div1}>
                        <a>Quantidade de Funcionarios</a>
                        <select onChange={(e) => setQtd(e.target.value)}>
                            <option value="0">0 - 30</option>
                            <option value="1">31 - 50</option>
                            <option value="2">51 - 100</option>
                            <option value="3">+ 100</option>
                        </select >
                    </div>
                    <div className={styled.div1}>
                        <a>Faturamento Anual</a>
                        <select onChange={(e) => setFat(e.target.value)}>
                            <option value="0">12 mil - 50 mil</option>
                            <option value="1">51 mil - 100 mil</option>
                            <option value="2">101 mil - 500 mil</option>
                            <option value="3">+ 500 mil</option>
                        </select >
                    </div>
                </div>

            </div>
            <div className={styled.modalfooter} onClick={() => PutInfo()}>
                SALVAR
            </div>
        </div>
    )
}

export default ModalFatu;